<template>
  <div>
    <h4 class="text-center w-100">Logo for {{company.name}}</h4>
    <div class="logo-container">
      <div v-if="company.activeLogo">
        <img
          :src="`https://s3.us-east-2.amazonaws.com/panelvue-photos/logo/${company.activeLogo.uuid}`"
          class="logo"
        />
      </div>
      <b-card-img v-else src="/no-logo.png"></b-card-img>
    </div>
    <hr />
    <transition name="fade" mode="out-in">
      <div v-if="error" class="text-danger text-center pb-2">{{error}}</div>
    </transition>
    <div class="buttons">
      <button class="btn btn-warning" @click="$emit('close')">Cancel</button>
      <button class="btn btn-primary" disabled v-if="loading">
        Uploading
        <i class="fa fa-spin fa-spinner"></i>
      </button>
      <div v-else>
        <label for="img-upload" class="btn btn-primary mb-0">Upload New</label>
        <input
          id="img-upload"
          type="file"
          class="form-control-file file-upload"
          @change="(e) => uploadImage(e, company)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "company-logo",
  props: ["company"],
  data: () => ({
    loading: false,
    error: "",
    filter: ""
  }),
  methods: {
    async uploadImage(e, company) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      company.file = files[0];

      try {
        this.error = "";
        this.loading = true;
        const response = await this.$web.updateCompanyLogo(company);

        if (response.data.updatedCompany) {
          this.company.activeLogo = response.data.updatedCompany.activeLogo;
          this.$emit("close");
        } else {
          this.error = "Failed to update logo";
        }
      } catch (e) {
        if (e.response && e.response.status === 413) {
          this.error = "File too large.";
        } else {
          this.error = "Unable to update logo.";
        }
      } finally {
        this.loading = false;
      }
    }
  },
  async mounted() {}
};
</script>

<style scoped>
.logo {
  max-width: 3in;
  max-height: 0.75in;
  object-fit: contain;
}

.logo-container {
  height: 0.89in;
  display: flex;
  align-items: center;
  justify-content: center;
}

#img-upload {
  display: none;
}

.buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
